import { Box, Container, Grid, Typography, Card, CardContent, useTheme, Button } from '@mui/material';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import xhiminet from '../../assets/xhiminet.png';
import shimajnet from '../../assets/shimajnet.png';
import fabbtel from '../../assets/fabbtel.png';
// Actual ISPs from original source
const clients = [
  {
    name: 'XhimiNet',
    logo: xhiminet,
    location: 'Elbasan, Albania',
    website: 'https://xhiminet.al'
  }, 
  {
    name: 'ShimajNet',
    logo: shimajnet,
    location: 'Shkodër & Lezhë, Albania',
    website: 'https://www.shimaj-net.al/'
  },
  {
    name: 'Fabbtel',
    logo: fabbtel,
    location: 'Elbasan, Albania',
    website: 'https://www.fabbtel.net/'
  }
];

const ClientsSection = () => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        py: { xs: 6, md: 10 },
        backgroundColor: theme.palette.mode === 'dark' ? theme.palette.background.light : '#f8f9fa',
      }}
    >
      <Container>
        <Box sx={{ textAlign: 'center', mb: 6 }}>
          <Typography
            variant="h2"
            component="h2"
            fontWeight="bold"
            color="text.primary"
            sx={{ mb: 2 }}
          >
            Trusted by ISPs
          </Typography>
          <Typography
            variant="subtitle1"
            color="text.secondary"
            sx={{ maxWidth: '700px', mx: 'auto' }}
          >
            Currently serving 7 ISPs in Albania with 19,000+ users
          </Typography>
        </Box>

        {/* Client Cards */}
        <Grid container spacing={4} justifyContent="center">
          {clients.map((client, index) => (
            <Grid item xs={12} md={4} key={index}>
              <Card 
                sx={{ 
                  height: '100%',
                  transition: 'all 0.3s ease',
                  '&:hover': {
                    transform: 'translateY(-10px)',
                    boxShadow: '0 15px 40px rgba(0,0,0,0.1)',
                  }
                }}
              >
                <CardContent>
                  <Box 
                    sx={{ 
                      mb: 3, 
                      height: 100, 
                      display: 'flex', 
                      alignItems: 'center', 
                      justifyContent: 'center' 
                    }}
                  >
                    <Box
                      component="img"
                      src={client.logo}
                      alt={`${client.name} Logo`}
                      sx={{
                        maxWidth: '100%',
                        maxHeight: '100%',
                      }}
                    />
                  </Box>
                  <Typography variant="h5" component="h3" gutterBottom sx={{ textAlign: 'center' }}>
                    {client.name}
                  </Typography>
                  <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                    <LocationOnIcon sx={{ color: theme.palette.text.secondary, mr: 1, fontSize: '1rem' }} />
                    <Typography variant="body2" color="text.secondary">
                      {client.location}
                    </Typography>
                  </Box>
                  <Typography variant="body2" sx={{ mb: 3, color: theme.palette.text.secondary }}>
                    {client.description}
                  </Typography>
                  <Button 
                    href={client.website} 
                    target="_blank" 
                    rel="noopener noreferrer" 
                    variant="outlined" 
                    color="primary" 
                    fullWidth
                  >
                    Visit Website
                  </Button>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>

        {/* Client Stats */}
        <Box sx={{ textAlign: 'center', mt: 6 }}>
          <Card sx={{ maxWidth: 800, mx: 'auto' }}>
            <CardContent>
              <Grid container>
                <Grid item xs={12} sm={6} md={3} sx={{ borderRight: { sm: 1 }, borderColor: 'divider', p: 2 }}>
                  <Typography variant="h3" fontWeight="bold" color="primary">
                    7+
                  </Typography>
                  <Typography variant="body1" fontWeight="medium">
                    ISP Partners
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    Across Albania
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={6} md={3} sx={{ borderRight: { md: 1 }, borderColor: 'divider', p: 2 }}>
                  <Typography variant="h3" fontWeight="bold" color="primary">
                    80+
                  </Typography>
                  <Typography variant="body1" fontWeight="medium">
                    Operators
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    Daily active
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={6} md={3} sx={{ borderRight: { sm: 1 }, borderColor: 'divider', p: 2 }}>
                  <Typography variant="h3" fontWeight="bold" color="primary">
                    19,000+
                  </Typography>
                  <Typography variant="body1" fontWeight="medium">
                    Users
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    And growing
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={6} md={3} sx={{ p: 2 }}>
                  <Typography variant="h3" fontWeight="bold" color="primary">
                    22,500+
                  </Typography>
                  <Typography variant="body1" fontWeight="medium">
                    Services
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    Being managed
                  </Typography>
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </Box>
      </Container>
    </Box>
  );
};

export default ClientsSection; 